import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { ReferralProvider } from "@/context/ReferralContext";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { ReferralModal } from "@/components/ReferralModal";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import FidelityPage from "@/pages/FidelityPage";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerDashboard from "@/pages/CustomerDashboard";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <ReferralProvider>
            <AuthProvider>
              <CustomerAuthProvider>
                <ReferralModal />
                <Toaster position="top-center" richColors />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/servizi/:slug" element={<CategoryPage />} />
                  <Route path="/carta-fedelta" element={<FidelityPage />} />
                  <Route path="/p/:slug" element={<LegalPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/area-clienti" element={<CustomerDashboard />} />
                  <Route path="/area-clienti/login" element={<CustomerLogin />} />
                  <Route path="/area-clienti/registrati" element={<CustomerRegister />} />
                  <Route path="/promo/:slug" element={<LandingPage />} />
                </Routes>
              </CustomerAuthProvider>
            </AuthProvider>
          </ReferralProvider>
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
